// System module feature gating.
//
// The login response bakes the company's SystemModule list into
// authUser.get_systemmodule_list (see AuthLoginController). Settings > Modules
// keeps that list in sync in localStorage when an admin toggles a module, so
// feature-gated UI can react without a re-login.
//
// Use isSystemModuleActive("CRM_...") to decide whether to render a module's UI.

export const isSystemModuleActive = (code) => {
  try {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const modules = authUser?.get_systemmodule_list || [];
    const match = modules.find((module) => module?.Code === code);
    return match ? Number(match.Active) === 1 : false;
  } catch (_) {
    return false;
  }
};

// Change #100696 - for DEFAULT-ON modules: a missing row counts as on, so the
// feature does not vanish before the seeding delta has run or for a login
// payload taken before it did. Only an explicit Active = 0 turns it off.
export const isSystemModuleOn = (code) => {
  try {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const modules = authUser?.get_systemmodule_list || [];
    const match = modules.find((module) => module?.Code === code);
    return match ? Number(match.Active) === 1 : true;
  } catch (_) {
    return true;
  }
};

// Well-known module codes, so gating call-sites don't hard-code magic strings.
export const SYSTEM_MODULE_CODES = {
  CUSTOMER_VEHICLE: "CRM_CUSTOMER_VEHICLE",
  CUSTOMER_JOBS_PORTAL: "CRM_CUSTOMER_JOBS_PORTAL",
  MICROSOFT365_LICENSING: "CRM_MICROSOFT365_LICENSING",
  // Covers the whole hospitality side - table reservations AND food pre-order
  // events; there is only one food module (Task 24527).
  FOOD_RESERVATION: "CRM_FOOD_RESERVATION",
  // Change #100326
  WHATSAPP: "CRM_WHATSAPP",
  // Change #100696 - default on; use isSystemModuleOn.
  TIME_TRACKING: "CRM_TIME_TRACKING",
};
